import { render, staticRenderFns } from "./AppRadiobox.vue?vue&type=template&id=578c61e3&scoped=true&"
import script from "./AppRadiobox.vue?vue&type=script&lang=js&"
export * from "./AppRadiobox.vue?vue&type=script&lang=js&"
import style0 from "./AppRadiobox.vue?vue&type=style&index=0&id=578c61e3&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578c61e3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgRadioButtonChecked: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/RadioButtonChecked.vue').default,SvgRadioButtonUnchecked: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/RadioButtonUnchecked.vue').default})
